import { useLocation } from "react-router-dom"

const useQueryString = (key: string, fallback?: string): string => {
  const { search } = useLocation()

  const searchParam = new URLSearchParams(search)

  const param = searchParam.get(key)
  if (Array.isArray(param) && param.length) {
    return param[0] ?? fallback ?? ""
  }
  return param ?? fallback ?? ""
}

export default useQueryString
